export default "__VITE_ASSET__BiyccEVR__"